import React, { useState, useEffect } from "react";
import { Navigate } from "react-router";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import { Chart } from "chart.js/auto";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BusinessIcon from "@mui/icons-material/Business";
import CategoryIcon from "@mui/icons-material/Category";
import PeopleIcon from "@mui/icons-material/People";
import PrintIcon from "@mui/icons-material/Print";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ChartPieChartOutlabels from "@energiency/chartjs-plugin-piechart-outlabels";
import iconforfvlogo from "../icons/fvlogo.png";
import { Helmet } from "react-helmet";
import favicon from "../icons/fvlogo.ico";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import FundTypeComposition from "../newComp/FundTypeComposition";
import { useSnackbar } from "notistack";
import moment from "moment";
import { DATE_FORMATS } from "../utils/constants";

// const pluginccbc = {
//   id: "customCanvasBackgroundColor",
//   beforeDraw: (chart, args, options) => {
//     const { ctx } = chart;
//     ctx.save();
//     ctx.globalCompositeOperation = "destination-over";
//     ctx.fillStyle = options.color || "transparent";
//     ctx.fillRect(0, 0, chart.width, chart.height);
//     ctx.restore();
//   },
// };

Chart.register(ChartPieChartOutlabels);

function Dashhwm() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });

  //Use notistack
  const { enqueueSnackbar } = useSnackbar();

  // Data table for Investment Route
  const [originalData, setoriginalData] = useState([]); // Original data loaded for the logged on investor
  const [v1inv, setv1inv] = useState([]); // Copy of the original data on which the data is loaded

  // Measures calculated out of the v1inv data
  const [total_inv, settotal_inv] = useState([]);
  const [current_value, setcurrent_value] = useState([]);
  const [pnl, setpnl] = useState([]);
  // const [funds_invested, setfunds_invested] = useState([]);
  const [startups_covered, setstartups_covered] = useState([]);
  const [domains_covered, setdomains_covered] = useState([]);
  const [investors_covered, setinvestors_covered] = useState([]);
  // const [latest_date, setlatest_date] = useState([]);
  const [wealth_manager, setwealth_manager] = useState([]);
  // const [rlatest_date, setrlatest_date] = useState([]);
  // const [current_date, setcurrent_date] = useState([]);
  // const [iname, setiname] = useState([]);
  // const [iid, setiid] = useState([]);
  const [tdata, settdata] = useState([]);
  // for horizontal bar chart
  const [chartData, setChartData] = useState(null);
  // const [chartHeight, setChartHeight] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    investors: [],
    funds: [],
    startups: [],
    domains: [],
    fundType: [],
  });

  // for filter selection menu
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  //_____________________________________

  // Logout link function
  const handleLinkClickfvwm = async () => {
    try {
      localStorage.removeItem("finvolveWealthManagerData");
      Navigate("/wealth-manager-login");
    } catch (error) {
      console.error(error);
    }
  };

  // console.log(v1inv)
  useEffect(() => {
    async function fetchData() {
      try {
        const finvolveWealthManagerData = JSON.parse(
          localStorage.getItem("finvolveWealthManagerData"),
        );
        // one set of data for all measures and visuals for investors
        const responsev1inv = await fetch(
          `${API_BASE_URL}/api/wealth-manager/investments/${finvolveWealthManagerData?.email}`,
          {
            headers: {
              Authorization: `Bearer ${finvolveWealthManagerData?.jwt}`,
            },
          },
        );
        const { data } = await responsev1inv.json();

        setLoading(false);

        const v1inv = data?.investments?.map((ele) => {
          const formatteddIssueDate2 = ele.issuedate2;
          const formattedCdate2 = ele.Cdate2;
          if (isNaN(ele.Cval_l || ele.pnl || ele.pnlp)) {
            enqueueSnackbar("⚠️ Warning: Something went wrong!", {
              variant: "error",
              autoHideDuration: 4000,
            });
          }
          return {
            ...ele,
            issuedate2: formatteddIssueDate2,
            Cdate2: formattedCdate2,
          };
        });

        setv1inv(v1inv || []);
        setoriginalData(v1inv || []);

        // Calculations for the Measures below

        // Total Investments
        const sumIvalL = v1inv?.reduce((accumulator, currentValue) => {
          return accumulator + parseFloat(currentValue.ival_l);
        }, 0);
        settotal_inv(sumIvalL);

        // Current Value Total
        const sumCvalL = v1inv?.reduce((accumulator, currentValue) => {
          return accumulator + parseFloat(currentValue.Cval_l);
        }, 0);
        setcurrent_value(sumCvalL);

        // Unrealized P&L Value Total
        const pnl = v1inv?.reduce((accumulator, currentValue) => {
          return accumulator + parseFloat(currentValue.pnl);
        }, 0);
        setpnl(pnl);

        // Funds Invested
        // const distinctFundsCount = [
        //   ...new Set(v1inv?.map((investment) => investment.fundname)),
        // ]?.length;
        // setfunds_invested(distinctFundsCount);

        // Startups Covered
        const distinctSUCount = [
          ...new Set(v1inv?.map((investment) => investment.startupname)),
        ].length;
        setstartups_covered(distinctSUCount);

        // Domains Covered
        const distinctdomainCount = [
          ...new Set(v1inv?.map((investment) => investment.SU_Domain)),
        ].length;
        setdomains_covered(distinctdomainCount);

        // investors Covered
        const distinctinvestorsCount = [
          ...new Set(v1inv?.map((investment) => investment.investor)),
        ].length;
        setinvestors_covered(distinctinvestorsCount);

        // Use reduce to find the latest date
        // const latestDate = v1inv?.reduce((latest, item) => {
        //   const itemDate = new Date(item.issuedate2);
        //   return itemDate > latest ? itemDate : latest;
        // }, new Date("1900-01-01"));
        // Format the latest date as 'dd-Mmm-yyyy'
        // const formattedDate = latestDate?.toLocaleDateString("en-GB", {
        //   day: "2-digit",
        //   month: "short",
        //   year: "numeric",
        // });
        // setlatest_date(formattedDate);

        // wealth_manager
        const wealthmanagers = [
          ...new Set(v1inv?.map((item) => item.wealthmanager)),
        ];
        setwealth_manager(wealthmanagers);

        //rlatest_date
        // const rlatest_date = v1inv?.reduce((acc, curr) => {
        //   const accDate = new Date(acc.Cdate2);
        //   const currDate = new Date(curr.Cdate2);
        //   return accDate > currDate ? acc : curr;
        // }).Cdate2;
        // setrlatest_date(rlatest_date);

        //current_time_am_pm
        // const dateObj = new Date();
        // const day = dateObj.getDate();
        // const month = dateObj.toLocaleString("default", { month: "short" });
        // const year = dateObj.getFullYear();
        // setcurrent_date(`${day}-${month}-${year}`);

        // Investor Name
        // const iname = [...new Set(v1inv?.map((item) => item.investor))];
        // setiname(iname);

        // Investor ID
        // const iid = [...new Set(v1inv?.map((item) => item.wlogin))];
        // setiid(iid);

        //reverse chronologically arranged dates for the table data
        settdata(
          v1inv?.length > 0
            ? [...v1inv].sort((a, b) => {
                console.log("a", a.issuedate2, "b", b.issuedate2);
                const dateA = moment(a.issuedate2, DATE_FORMATS, true);
                const dateB = moment(b.issuedate2, DATE_FORMATS, true);

                if (!dateA.isValid()) return 1; // Invalid dates go to the end
                if (!dateB.isValid()) return -1;

                return dateB - dateA; // Newest to oldest
              })
            : [],
        );

        // // data for horizontal bar chart
        // if (investorsdata.length > 0) {
        //   const colors = [
        //     "#3281B7", "#2E927C", "#EF9921", "#7EA8C2", "#73A59C", "#F7CC8B", "#E87934", "#666666",
        //     "#3599B8", "#DFBFBF", "#4AC5BB", "#5F6B6D", "#F4D25A", "#7F898A", "#A4DDEE", "#FDAB89"
        //   ];

        //   // Calculate the total Cval_l for individual investors
        //   const investorTotals = investorsdata.map(investorData => ({
        //     investor: investorData.investor,
        //     totalCval: investorData.Cval_l.reduce((total, value) => total + value, 0)
        //   }));

        //   // Sort the investorTotals array in descending order based on totalCval
        //   investorTotals.sort((a, b) => b.totalCval - a.totalCval);

        //   const investors_and_investment_data = {
        //     labels: [],
        //     datasets: []
        //   };

        //   // Create an array of unique fund names
        //   const fundNames = [];
        //   investorsdata.forEach(function(investorData) {
        //     investorData.fundname.forEach(function(fundname) {
        //       if (fundNames.indexOf(fundname) === -1) {
        //         fundNames.push(fundname);
        //       }
        //     });
        //   });

        //   // Populate labels array
        //   investorTotals.forEach(function(investorTotal) {
        //     investors_and_investment_data.labels.push(investorTotal.investor);
        //   });

        //   // Populate datasets array
        //   fundNames.forEach(function(fundname, index) {
        //     const data = [];
        //     investorTotals.forEach(function(investorTotal) {
        //       const investorData = investorsdata.find(data => data.investor === investorTotal.investor);
        //       const index = investorData.fundname.indexOf(fundname);
        //       const value = (index !== -1) ? investorData.Cval_l[index] : 0;
        //       data.push(value);
        //     });

        //     investors_and_investment_data.datasets.push({
        //       label: fundname,
        //       data: data,
        //       backgroundColor: colors[index % colors.length] // Set the background color
        //     });
        //   });

        //   setChartData(investors_and_investment_data);
        //   const numBars = investors_and_investment_data.labels.length;
        //   const defaultHeight = 250;
        //   const dynamicHeight = Math.max(numBars * 40, defaultHeight);
        //   setChartHeight(dynamicHeight);
        // }

        // data for horizontal bar chart
        if (investorsdata.length > 0) {
          // Calculate the total Cval_l for individual investors
          const investorTotals = investorsdata.map((investorData) => ({
            investor: investorData.investor,
            totalCval: investorData.Cval_l.reduce(
              (total, value) => total + value,
              0,
            ),
          }));

          // Sort the investorTotals array in descending order based on totalCval
          investorTotals.sort((a, b) => b.totalCval - a.totalCval);

          const investors_and_investment_data = {
            labels: [],
            datasets: [],
          };

          // Populate labels array
          investorTotals.forEach(function (investorTotal) {
            investors_and_investment_data.labels.push(investorTotal.investor);
          });

          // Populate datasets array
          investors_and_investment_data.datasets.push({
            label: "Current Value",
            data: investorTotals.map(
              (investorTotal) => investorTotal.totalCval,
            ),
            backgroundColor: "#3281B7",
            borderRadius: 8,
            borderSkipped: false,
          });

          setChartData(investors_and_investment_data);
          // const numBars = investors_and_investment_data.labels.length;
          // const defaultHeight = 250;
          // const dynamicHeight = Math.max(numBars * 40, defaultHeight);
          // setChartHeight(dynamicHeight);
        }
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    }
    fetchData();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const filteredData = originalData.filter(
      (item) =>
        (filters.investors.length === 0 ||
          filters.investors.includes(item.investor)) &&
        (filters.funds.length === 0 || filters.funds.includes(item.fundname)) &&
        (filters.startups.length === 0 ||
          filters.startups.includes(item.startupname)) &&
        (filters.domains.length === 0 ||
          filters.domains.includes(item.SU_Domain)) &&
        (filters.fundType.length === 0 ||
          filters.fundType.includes(item.fundType)),
    );
    setv1inv(filteredData);
  }, [filters, originalData]);

  useEffect(() => {
    // Calculations for the Measures below

    // Total Investments
    const sumIvalL = v1inv.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.ival_l);
    }, 0);
    settotal_inv(sumIvalL);

    // Current Value Total
    const sumCvalL = v1inv.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.Cval_l);
    }, 0);
    setcurrent_value(sumCvalL);

    // Unrealized P&L Value Total
    const pnl = v1inv.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.pnl);
    }, 0);
    setpnl(pnl);

    // Funds Invested
    // const distinctFundsCount = [
    //   ...new Set(v1inv.map((investment) => investment.fundname)),
    // ].length;
    // setfunds_invested(distinctFundsCount);

    // Startups Covered
    const distinctSUCount = [
      ...new Set(v1inv.map((investment) => investment.startupname)),
    ].length;
    setstartups_covered(distinctSUCount);

    // Domains Covered
    const distinctdomainCount = [
      ...new Set(v1inv.map((investment) => investment.SU_Domain)),
    ].length;
    setdomains_covered(distinctdomainCount);

    // Use reduce to find the latest date
    // const latestDate = v1inv.reduce((latest, item) => {
    //   const itemDate = new Date(item.issuedate2);
    //   return itemDate > latest ? itemDate : latest;
    // }, new Date("1900-01-01"));
    // Format the latest date as 'dd-Mmm-yyyy'
    // const formattedDate = latestDate.toLocaleDateString("en-GB", {
    //   day: "2-digit",
    //   month: "short",
    //   year: "numeric",
    // });
    // setlatest_date(formattedDate);
    // console.log("6. Last Investment Date " + (latest_date) + ".");

    // // wealth_manager
    // const wealthmanagers = [...new Set(v1inv.map(item => item.wealthmanager))];
    // setwealth_manager(wealthmanagers);
    // console.log("7. Wealth Manager Name :- "+ (wealth_manager) + ".");

    // //rlatest_date
    // const rlatest_date = v1inv.reduce((acc, curr) => {
    //   return acc.Cdate2 > curr.Cdate2 ? acc : curr;
    // }).Cdate2;
    // setrlatest_date(rlatest_date);
    // console.log("13. Report Updated on :- "+ (rlatest_date) + ".");

    // //current_time_am_pm
    // const dateObj = new Date();
    // const day = dateObj.getDate();
    // const month = dateObj.toLocaleString('default', { month: 'short' });
    // const year = dateObj.getFullYear();
    // setcurrent_date(`${day}-${month}-${year}`);

    // // Investor Name
    // const iname = [...new Set(v1inv.map(item => item.investor))];
    // setiname(iname);
    // console.log("15. Investor Name :- "+ (iname) + ".");

    // // Investor ID
    // const iid = [...new Set(v1inv.map(item => item.ilogin))];
    // setiid(iid);
    // console.log("15. Investor id :- "+ (iid) + ".");

    //reverse chronologically arranged dates for the table data
    settdata(
      [...v1inv].sort((a, b) => {
        const dateA = moment(a.issuedate2, DATE_FORMATS, true);
        const dateB = moment(b.issuedate2, DATE_FORMATS, true);

        if (!dateA.isValid()) return 1;
        if (!dateB.isValid()) return -1;

        return dateB - dateA; // Descending order
      }),
    );

    // //data for horizontal bar chart
    // if (investorsdata.length > 0) {
    //   const colors = [
    //     "#3281B7", "#2E927C", "#EF9921", "#7EA8C2", "#73A59C", "#F7CC8B", "#E87934", "#666666",
    //     "#3599B8", "#DFBFBF", "#4AC5BB", "#5F6B6D", "#F4D25A", "#7F898A", "#A4DDEE", "#FDAB89"
    //   ];

    //   // Calculate the total Cval_l for individual investors
    //   const investorTotals = investorsdata.map(investorData => ({
    //     investor: investorData.investor,
    //     totalCval: investorData.Cval_l.reduce((total, value) => total + value, 0)
    //   }));

    //   // Sort the investorTotals array in descending order based on totalCval
    //   investorTotals.sort((a, b) => b.totalCval - a.totalCval);

    //   const investors_and_investment_data = {
    //     labels: [],
    //     datasets: []
    //   };

    //   // Create an array of unique fund names
    //   const fundNames = [];
    //   investorsdata.forEach(function(investorData) {
    //     investorData.fundname.forEach(function(fundname) {
    //       if (fundNames.indexOf(fundname) === -1) {
    //         fundNames.push(fundname);
    //       }
    //     });
    //   });

    //   // Populate labels array
    //   investorTotals.forEach(function(investorTotal) {
    //     investors_and_investment_data.labels.push(investorTotal.investor);
    //   });

    //   // Populate datasets array
    //   fundNames.forEach(function(fundname, index) {
    //     const data = [];
    //     investorTotals.forEach(function(investorTotal) {
    //       const investorData = investorsdata.find(data => data.investor === investorTotal.investor);
    //       const index = investorData.fundname.indexOf(fundname);
    //       const value = (index !== -1) ? investorData.Cval_l[index] : 0;
    //       data.push(value);
    //     });

    //     investors_and_investment_data.datasets.push({
    //       label: fundname,
    //       data: data,
    //       backgroundColor: colors[index % colors.length] // Set the background color
    //     });
    //   });
    // console.log(JSON.stringify(investors_and_investment_data,null,2))
    //   setChartData(investors_and_investment_data);
    //   const numBars = investors_and_investment_data.labels.length;
    //   const defaultHeight = 250;
    //   const dynamicHeight = Math.max(numBars * 40, defaultHeight);
    //   setChartHeight(dynamicHeight);
    // }
    // data for horizontal bar chart
    if (investorsdata.length > 0) {
      // Calculate the total Cval_l for individual investors
      const investorTotals = investorsdata.map((investorData) => ({
        investor: investorData.investor,
        totalCval: investorData.Cval_l.reduce(
          (total, value) => total + value,
          0,
        ),
      }));

      // Sort the investorTotals array in descending order based on totalCval
      investorTotals.sort((a, b) => b.totalCval - a.totalCval);

      const investors_and_investment_data = {
        labels: [],
        datasets: [],
      };

      // Populate labels array
      investorTotals.forEach(function (investorTotal) {
        investors_and_investment_data.labels.push(investorTotal.investor);
      });

      // Populate datasets array
      investors_and_investment_data.datasets.push({
        label: "Current Value",
        data: investorTotals.map((investorTotal) => investorTotal.totalCval),
        backgroundColor: "#3B82F6",
        borderRadius: 8,
        borderSkipped: false,
        barPercentage: 0.7,
        categoryPercentage: 0.8,
      });

      setChartData(investors_and_investment_data);
      // const numBars = investors_and_investment_data.labels.length;
      // const defaultHeight = 250;
      // const dynamicHeight = Math.max(numBars * 40, defaultHeight);
      // setChartHeight(dynamicHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [v1inv, filters]);

  // below for dropdowns

  // checkbox for funds
  const checks_funds = [...new Set(originalData.map((item) => item.fundname))];
  const [cfundsName, setcfundsName] = useState([]);
  const handleChangecfunds = (event) => {
    const { value } = event.target;
    const selectedFunds = Array.isArray(value) ? value : [value];
    setcfundsName(selectedFunds);

    // Filter v1inv array by selected funds
    const filteredV1inv =
      selectedFunds.length > 0
        ? originalData.filter((item) => selectedFunds.includes(item.fundname))
        : originalData;

    // Set v1inv state to filtered v1inv array
    setv1inv(filteredV1inv);
  };

  // checkbox for funds
  const checks_startup = [
    ...new Set(originalData.map((item) => item.startupname)),
  ];
  const [cstartupName, setcstartupName] = useState([]);
  const handleChangecstartup = (event) => {
    const { value } = event.target;
    const selectedStartups = Array.isArray(value) ? value : [value];
    setcstartupName(selectedStartups);

    // Filter v1inv array by selected funds
    const filteredV1inv =
      selectedStartups.length > 0
        ? originalData.filter((item) =>
            selectedStartups.includes(item.startupname),
          )
        : originalData;

    // Set v1inv state to filtered v1inv array
    setv1inv(filteredV1inv);
  };

  // checkbox for Domain
  const checks_domain = [
    ...new Set(originalData.map((item) => item.SU_Domain)),
  ];
  const [cdomainName, setcdomainName] = useState([]);
  const handleChangecdomain = (event) => {
    const { value } = event.target;
    const selectedDomains =
      typeof value === "string" ? value.split(",") : value;
    setcdomainName(selectedDomains);

    // Filter v1inv array by selected funds
    const filteredV1inv =
      selectedDomains.length > 0
        ? originalData.filter((item) =>
            selectedDomains.includes(item.SU_Domain),
          )
        : originalData;

    // Set v1inv state to filtered v1inv array
    setv1inv(filteredV1inv);
  };

  // const filteredData = useMemo(() => {
  //   return v1inv.filter(item => {
  //     return (
  //       (filters.investors.length === 0 || filters.investors.includes(item.investor)) &&
  //       (filters.funds.length === 0 || filters.funds.includes(item.fundname)) &&
  //       (filters.startups.length === 0 || filters.startups.includes(item.startupname)) &&
  //       (filters.domains.length === 0 || filters.domains.includes(item.SU_Domain))
  //     );
  //   });
  //   // setv1inv(x);
  // }, [v1inv, filters]);

  const handleClearFilters = () => {
    setcfundsName([]);
    setcstartupName([]);
    setcdomainName([]);
    setFilters({
      investors: [],
      funds: [],
      startups: [],
      domains: [],
      fundType: [],
    });
  };

  // above for dropdowns

  // data for table2

  const tdata2 = Object.values(
    v1inv.reduce((acc, { investor, fundname, startupname, ival_l, Cval_l }) => {
      if (!acc[investor]) {
        acc[investor] = {
          investor,
          fundcount: 0,
          startupcount: 0,
          invested_value: 0,
          currentvalue_value: 0,
          pnlvalue: 0,
          pnlpercent: 0,
        };
      }

      acc[investor].fundcount += 1;
      acc[investor].startupcount += new Set([startupname]).size;
      acc[investor].invested_value += parseFloat(ival_l);
      acc[investor].currentvalue_value += parseFloat(Cval_l);
      acc[investor].pnlvalue += parseFloat(Cval_l) - parseFloat(ival_l);
      acc[investor].pnlpercent =
        ((parseFloat(Cval_l) - parseFloat(ival_l)) / parseFloat(ival_l)) * 100;

      return acc;
    }, {}),
  ).sort((a, b) => b.currentvalue_value - a.currentvalue_value);

  //other data below

  //for page 2 line chart 2
  const datap2 = {
    labels: [],
    datasets: [
      {
        label: "Number of Investors",
        data: [],
        fill: false,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };

  // Group the input data by month
  const wmpage2line = v1inv.reduce((acc, curr) => {
    const month = curr.issuedate2.split("-")[1]; // Extract the month from the issuedate2 field
    if (!acc[month]) {
      acc[month] = { month: month, count: 0 };
    }
    acc[month].count++;
    return acc;
  }, {});

  // Convert the grouped data into the format expected by Chart.js
  Object.values(wmpage2line).forEach((item) => {
    datap2.labels.push(item.month);
    datap2.datasets[0].data.push(item.count);
  });
  //_____________________________________________________________________________________________________________________________________________________________
  // Data and options for Composition of Startups waterfall chart

  // prepping data for wf step1 grouping startups,
  const startupsandcvsum = {};
  for (let i = 0; i < v1inv.length; i++) {
    const startup = v1inv[i];
    const startupName = startup.startupname;
    const Cval_l = parseFloat(startup.Cval_l);

    if (startupsandcvsum[startupName]) {
      startupsandcvsum[startupName].Cval_l += Cval_l;
    } else {
      startupsandcvsum[startupName] = {
        startupname: startupName,
        Cval_l: Cval_l,
      };
    }
  }
  const startupsandcvsumfinal = Object.values(startupsandcvsum);

  let startupsData = {};
  startupsandcvsumfinal.sort(
    (a, b) => parseFloat(b.Cval_l) - parseFloat(a.Cval_l),
  );
  let total = 0;
  for (let i = 0; i < startupsandcvsumfinal.length; i++) {
    const startup = startupsandcvsumfinal[i];
    const currentValue = [total, total + parseFloat(startup.Cval_l)];
    startupsData[startup.startupname] = currentValue.join(",");
    total += parseFloat(startup.Cval_l);
  }
  startupsData["Total"] = `0,${total}`;
  // console.log(JSON.stringify(startupsData,null,2));
  // const composition_of_startups_data = {
  //   labels: Object.keys(startupsData),
  //   datasets: [
  //     {
  //       data: Object.values(startupsData).map((value) => {
  //         const numbers = value.split(",");
  //         return [Number(numbers[0]), Number(numbers[1])];
  //       }),
  //       barPercentage: 1.2,
  //     },
  //   ],
  // };
  // backgroundColor: ["#3281B7", "#2E927C", "#EF9921", "#7EA8C2", "#73A59C", "#F7CC8B", "#E87934", "#666666", "#3599B8", "#DFBFBF", "#4AC5BB", "#5F6B6D", "#F4D25A", "#7F898A", "#A4DDEE", "#FDAB89"],

  const labels = Object.keys(startupsData);
  const colors = [];
  for (let i = 0; i < labels.length; i++) {
    if (labels[i] !== "Total") {
      colors.push("#2E927C"); // add color for startups
    } else {
      colors.push("#3281B7"); // add color for total
    }
  }

  const composition_of_startups_data = {
    labels: startupsandcvsumfinal.map((startup) => startup.startupname),
    datasets: [
      {
        label: "Current Value",
        data: startupsandcvsumfinal.map((startup) => startup.Cval_l),
        borderColor: "#10B981",
        borderWidth: 3,
        fill: false,
        tension: 0.4,
        pointBackgroundColor: "#10B981",
        pointBorderColor: "#FFFFFF",
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointHoverBackgroundColor: "#059669",
        pointHoverBorderColor: "#FFFFFF",
        pointHoverBorderWidth: 3,
      },
    ],
  };

  // options for the chart
  const composition_of_startups_options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: "easeInOutQuart",
      delay: (context) => context.dataIndex * 200,
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    labels: {
      display: false,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Startup Name",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 15,
            bottom: 10,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Current Value",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 10,
            bottom: 15,
          },
        },
        grid: {
          color: "rgba(107, 114, 128, 0.1)",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          callback: function (value, index, ticks) {
            return "₹" + value + "L";
          },
        },
        border: {
          display: false,
        },
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 30,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        bodyColor: "#1F2937",
        titleColor: "#374151",
        borderColor: "rgba(226, 232, 240, 0.8)",
        borderWidth: 1,
        cornerRadius: 12,
        displayColors: true,
        titleFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 13,
          weight: 600,
        },
        bodyFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 12,
          weight: 500,
        },
        padding: 16,
        boxShadow:
          "0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05)",
        callbacks: {
          label: function (context) {
            var value = context.dataset.data[context.dataIndex];
            var result = Number(value).toFixed(2);
            return "Current Value: ₹" + result + "L";
          },
        },
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: false,
      },
    },
  };

  //_____________________________________________________________________________________________________________________________________________________________

  // Domain data - gdatadomain which is used for Domain Composition pie/Doughnut chart
  const domainDataa = {};
  v1inv.forEach((item) => {
    if (!domainDataa[item.SU_Domain]) {
      domainDataa[item.SU_Domain] = 0;
    }
    domainDataa[item.SU_Domain] += parseFloat(item.Cval_l);
  });
  ///sorting the above data in descending order
  const domainData = Object.entries(domainDataa)
    .sort((a, b) => b[1] - a[1])
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  const domain_composition_data = {
    labels: Object.keys(domainData),
    datasets: [
      {
        data: Object.values(domainData).map((value) => value),
        backgroundColor: [
          "#3281B7",
          "#2E927C",
          "#EF9921",
          "#7EA8C2",
          "#73A59C",
          "#F7CC8B",
          "#E87934",
          "#666666",
          "#3599B8",
          "#DFBFBF",
          "#4AC5BB",
          "#5F6B6D",
          "#F4D25A",
          "#7F898A",
          "#A4DDEE",
          "#FDAB89",
        ],
      },
    ],
  };

  const domain_composition_options = {
    animation: true,
    // cutout: "30%",
    //circumference: 0,
    radius: "75%",
    layout: {
      padding: 50,
    },
    zoomOutPercentage: "70",
    plugins: {
      // datalabels: {
      // align: 'center',
      // anchor: 'end',
      // backgroundColor: 'black',
      // borderRadius:'5',
      // display: false,
      // // formatter:(value,context) => {
      // //   return context.chart.data.labels[context.dataIndex] + ': '+ `${value}%`;
      // // }
      // },
      outlabels: {
        display: true,
        // text: "%l \n₹%v.2L (%p.2) ",
        text: "%l ₹%v.2L",
        color: "black",
        // lineColor: "#4C4A48",
        lineWidth: "1",
        stretch: 1,
        font: {
          resizable: false,
          family: "Segoe UI",
          size: "10",
        },
        // backgroundColor: false,
        // formatter: function (value, context) {
        //   var percentage = context.dataset.percentages[context.dataIndex];
        //   if (percentage < 5) {
        //     return '';
        //   } else {
        //     return value;
        //   }
        // }
      },

      tooltip: {
        enabled: true,
        backgroundColor: "white",
        bodyColor: "Black",
        titleColor: "Black",
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            var value = context.dataset.data[context.dataIndex];
            var total = context.dataset.data.reduce((acc, val) => acc + val, 0);
            var percentage = ((value / total) * 100).toFixed(2);
            var result = value.toFixed(2);
            label +=
              "Current Value: " +
              "₹" +
              result +
              "L" +
              " (" +
              percentage +
              "% of Total)";
            return label;
          },
        },
      },

      title: {
        display: false,
        align: "start",
        text: "Current Valuation of Holdings - Startups",
        color: "Black",
        fontFamily: "Arial",
        fontSize: "18",
        padding: { bottom: 30 },
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
    },
    //customCanvasBackgroundColor: {
    //  color: 'white',
    //},
    responsive: true,
    maintainAspectRatio: false,
    //  plugins: [
    //    ChartPieChartOutlabels
    //  ]
  };

  //_____________________________________________________________________________________________________________________________________________________________
  // Data and Options for the investment value by month bar and line chart
  const transactionsByMonth = {};

  // iterate through the array of objects and calculate the total transactions by month
  v1inv.forEach((item) => {
    const month =
      item.issuedate2.split("-")[1] + "-" + item.issuedate2.split("-")[2]; // extract month-year in the format "Mon-Year"
    if (transactionsByMonth[month]) {
      transactionsByMonth[month].ival_l = (
        +transactionsByMonth[month].ival_l + +item.ival_l
      ).toFixed(1); // add to the total and keep only 1 decimal point
      transactionsByMonth[month].Transactions++;
    } else {
      transactionsByMonth[month] = {
        ival_l: item.ival_l,
        issuedate2: month,
        Transactions: 1,
      };
    }
  });

  // convert the object to an array and sort by issuedate2
  const transactionsdata1 = Object.values(transactionsByMonth).sort(
    (a, b) => new Date(a.issuedate2) - new Date(b.issuedate2),
  );

  // Create empty arrays to hold the labels and data
  const td1labels = [];
  const td1dataset1 = [];
  const td1dataset2 = [];

  // Iterate over the data array and extract the necessary values
  transactionsdata1.forEach((item) => {
    td1labels.push(item.issuedate2);
    td1dataset1.push(item.ival_l);
    td1dataset2.push(item.Transactions);
  });

  // Define the datasets object with two datasets (one for each line/bar)
  const td1datasets = [
    {
      label: "Cval_l",
      data: td1dataset1,
      backgroundColor: "#3281B7",
      type: "bar",
      // borderColor: "blue",
      fill: false,
      borderRadius: 8,
      borderSkipped: false,
    },
    // {
    //   label: "Transactions",
    //   data: td1dataset2,
    //   type: "line",
    //   backgroundColor: "#2E927C",
    // },
  ];

  // Define the chart data object with labels and datasets
  const investment_value_by_month_data = {
    labels: td1labels,
    datasets: td1datasets,
  };

  // options for the investment value by month bar and line chart
  const investment_value_by_month_options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: "easeInOutQuart",
      delay: (context) => context.dataIndex * 100,
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    labels: {
      display: false,
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Investment Value",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 10,
            bottom: 15,
          },
        },
        grid: {
          color: "rgba(107, 114, 128, 0.1)",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          callback: function (value, index, ticks) {
            return "₹" + value + "L";
          },
        },
        border: {
          display: false,
        },
      },
      x: {
        title: {
          display: true,
          text: "Month - Year",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 15,
            bottom: 10,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
        },
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 30,
        left: 20,
        right: 20,
      },
    },

    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        bodyColor: "#1F2937",
        titleColor: "#374151",
        borderColor: "rgba(226, 232, 240, 0.8)",
        borderWidth: 1,
        cornerRadius: 12,
        displayColors: true,
        titleFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 13,
          weight: 600,
        },
        bodyFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 12,
          weight: 500,
        },
        padding: 16,
        boxShadow:
          "0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05)",
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label = "Investment Value : ";
            }
            var value = context.dataset.data[context.dataIndex];
            var result = Number(value).toFixed(2);
            label += "₹" + result + "L";
            return label;
          },
        },
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: false,
      },
    },
  };

  //------------------------------------------------

  // Data and options for Investors Engaged Line chart
  const td2dataset = [
    {
      label: "Investors Engaged",
      data: td1dataset2,
      borderColor: "#2E927C",
      backgroundColor: "#EF9921",
      pointBackgroundColor: "#EF9921",
      pointBorderColor: "#EF9921",
      pointStyle: "rect",
      rotation: 45,
      radius: 4,
      type: "line",
    },
  ];

  const investors_engaged_data = {
    labels: td1labels,
    datasets: td2dataset,
  };

  const investors_engaged_options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: "easeInOutQuart",
      delay: (context) => context.dataIndex * 100,
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    labels: {
      display: false,
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Investor Count",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 10,
            bottom: 15,
          },
        },
        grid: {
          color: "rgba(107, 114, 128, 0.1)",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
        },
        border: {
          display: false,
        },
      },
      x: {
        title: {
          display: true,
          text: "Month - Year",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 15,
            bottom: 10,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
        },
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 30,
        left: 20,
        right: 20,
      },
    },

    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        bodyColor: "#1F2937",
        titleColor: "#374151",
        borderColor: "rgba(226, 232, 240, 0.8)",
        borderWidth: 1,
        cornerRadius: 12,
        displayColors: true,
        titleFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 13,
          weight: 600,
        },
        bodyFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 12,
          weight: 500,
        },
        padding: 16,
        boxShadow:
          "0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05)",
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            var value = context.dataset.data[context.dataIndex];
            label += value + " investors";
            return label;
          },
        },
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: false,
      },
    },
  };

  //____________________________________________________________________________________________________

  // Funds Data -  gData used for AUM breakdown

  const fundsData = {};
  v1inv.forEach((item) => {
    if (!fundsData[item.fundname]) {
      fundsData[item.fundname] = 0;
    }
    fundsData[item.fundname] += parseFloat(item.Cval_l);
  });

  // const aum_breakdown_data = {
  //   labels: Object.keys(fundsData),
  //   datasets: [
  //     {
  //       data: Object.values(fundsData).map((value) => value),
  //       backgroundColor: "#3281B7",
  //       barPercentage: 0.7,
  //     },
  //   ],
  // };

  //   const aum_breakdown_options  = {
  //     labels:{
  //       display:false
  //     },
  //     scales: {
  //               y: {
  //                 title:{
  //                   display: true,
  //                   text: 'Current Value',
  //                   color: 'black',
  //                   font:{
  //                     Family:"FF DIN",
  //                     size:'12',
  //                     // weight:'bold'
  //                   }
  //                 },
  //                 grid: {
  //                   drawOnChartArea: true,
  //                   // color: '#F7F7F7'
  //                 },
  //                 border: {
  //                   dash: [2,4]
  //                 },
  //                 ticks:{
  //                   callback: function(value, index, ticks) {
  //                     return '₹'+ value+'L';
  //                   }
  //                 }
  //               },
  //               x:{
  //                 ticks: {
  //                         autoSkip: false,
  //                         maxRotation: 0,
  //                         callback: (value, index, values) => {
  //                             let label = aum_breakdown_data.labels[value];
  //                             if(label == null){
  //                                 return '';
  //                             }
  //                             if (label.length > 15) {
  //                                 label = label.substring(0, 15);
  //                                 label += '..';
  //                             }
  //                                 return label;
  //                         },
  //                   },
  //                 title:{
  //                   display: true,
  //                   text: 'Startup Domain',
  //                   color: 'black',
  //                   font:{
  //                     Family:"Segoe UI",
  //                     size:'12',
  //                     // weight:'bold'
  //                   }
  //                 },
  //                 grid:{
  //                   drawOnChartArea:false
  //                 }
  //               }
  //     },
  //     //circumference: 0,
  //     layout: {
  //       padding: {
  //         top:20,
  //         bottom:15
  //       },
  //     },

  //     plugins: {
  //       tooltip: {
  //         enabled: true,
  //         backgroundColor: "white",
  //         bodyColor: "Black",
  //         titleColor: "Black",
  //         callbacks: {
  //           label: function(context) {
  //             var label = context.dataset.label || '';
  //             if (label) {
  //               label += ': ';
  //             }
  //             var value = context.dataset.data[context.dataIndex];
  //             var result = value.toFixed(2); // subtract the second part from the first part and round the result to two decimal places
  //             label += "AUM: " +'₹' + result + 'L';
  //             return label;
  //           }
  //         }
  //       },
  //       legend: {
  //         display: false,
  //         position: "right",
  //         align: "right",
  //       },
  //       datalabels: {
  //         display: 'true',
  //          align: 'start',
  //          anchor: 'end',
  //         //  color:'contrast',
  //          color:'Black',
  //          offset: -20,
  //         // backgroundColor: 'none',
  //         font:{
  //           Family:"Segoe UI",
  //           size:'14',
  //           weight:'none'
  //         },
  //         borderRadius:'5',
  //         formatter: function(value, context) {
  //           return '₹'+ value.toFixed(2) +'L';
  //         },
  //       },
  //     },
  //     responsive: true,
  //     maintainAspectRatio: false,
  // };

  //___________________________________________________________________________________________________
  // data and options for investors and ivnestments - fund wise chart

  const investorsdata = v1inv.reduce((acc, curr) => {
    const existingInvestor = acc.find(
      (item) => item.investor === curr.investor,
    );
    if (existingInvestor) {
      const existingFundIndex = existingInvestor.fundname.findIndex(
        (item) => item === curr.fundname,
      );
      if (existingFundIndex > -1) {
        existingInvestor.Cval_l[existingFundIndex] += parseFloat(curr.Cval_l);
      } else {
        existingInvestor.fundname.push(curr.fundname);
        existingInvestor.Cval_l.push(parseFloat(curr.Cval_l));
      }
    } else {
      acc.push({
        investor: curr.investor,
        fundname: [curr.fundname],
        Cval_l: [parseFloat(curr.Cval_l)],
      });
    }
    return acc;
  }, []);

  //_____

  // // create an empty object to hold the final output
  // const investors_and_investment_data = {
  //   labels: [1,2],
  //   datasets: [1,2]
  // };

  // Create an array of unique fund names
  // const fundNames = investorsdata.reduce((acc, curr) => {
  //   return [...acc, ...curr.fundname.filter((name) => !acc.includes(name))];
  // }, []);

  // // Create an object where each key is an investor name, and the value is an array of Cval_l values for each fund they invested in
  // const investorData = investorsdata.reduce((acc, curr) => {
  //   const investor = curr.investor;
  //   const cVals = curr.Cval_l;
  //   const data = {};
  //   curr.fundname.forEach((fund, index) => {
  //     data[fund] = cVals[index];
  //   });

  //   if (acc[investor]) {
  //     acc[investor].push(data);
  //   } else {
  //     acc[investor] = [data];
  //   }

  //   return acc;
  // }, {});

  // // Create the data object for the chart
  // const investors_and_investment_data2 = {
  //   labels: Object.keys(investorData),
  //   datasets: fundNames.map((name, index) => {
  //     return {
  //       label: name,
  //       backgroundColor: 'black', // Generate a random hex color
  //       data: Object.values(investorData).map((data) => {
  //         return data[name] || 0; // If the investor did not invest in this fund, set the value to 0
  //       })
  //     };
  //   })
  // };

  // const chartLabels = investorsdata.map(data => data.investor);

  // // // Generate chart datasets
  // const chartDatasets = [];

  // const fundNames = [...new Set(investorsdata.flatMap(data => data.fundname))];

  // for (const fundName of fundNames) {
  //   const fundData = investorsdata.map(data => {
  //     const index = data.fundname.indexOf(fundName);
  //     return (index >= 0) ? data.Cval_l[index] : 0;
  //   });
  //   chartDatasets.push({
  //     label: fundName,
  //     data: fundData,
  //     // backgroundColor: 'a0a7f9'
  //     //  stack: 'investors',
  //   });
  // }

  // // Generate chart data
  // const investors_and_investment_data3= {
  //   labels: chartLabels,
  //   datasets: chartDatasets,
  // };

  // var investors_and_investment_data = {
  //   labels: [],
  //   datasets: [],
  // };

  // // Create an array of unique fund names
  // var fundNames = [];
  // investorsdata.forEach(function(investorData) {
  //   investorData.fundname.forEach(function(fundname) {
  //     if (fundNames.indexOf(fundname) === -1) {
  //       fundNames.push(fundname);
  //     }
  //   });
  // });

  // // Populate labels array
  // investorsdata.forEach(function(investorData) {
  //   investors_and_investment_data3.labels.push(investorData.investor);
  // });

  // // Populate datasets array
  // fundNames.forEach(function(fundname) {
  //   var data = [];
  //   investorsdata.forEach(function(investorData) {
  //     var index = investorData.fundname.indexOf(fundname);
  //     var value = (index !== -1) ? investorData.Cval_l[index] : 0;
  //     data.push(value);
  //   });
  //   investors_and_investment_data3.datasets.push({
  //     label: fundname,
  //     data: data
  //   });
  // });

  //___________

  const investors_and_investment_options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: "easeInOutQuart",
      delay: (context) => context.dataIndex * 100,
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    indexAxis: "x",
    labels: {
      display: false,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Investors",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 15,
            bottom: 10,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Current Value",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 10,
            bottom: 15,
          },
        },
        grid: {
          color: "rgba(107, 114, 128, 0.1)",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          callback: function (value, index, ticks) {
            return "₹" + value + "L";
          },
        },
        border: {
          display: false,
        },
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 30,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        bodyColor: "#1F2937",
        titleColor: "#374151",
        borderColor: "rgba(226, 232, 240, 0.8)",
        borderWidth: 1,
        cornerRadius: 12,
        displayColors: true,
        titleFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 13,
          weight: 600,
        },
        bodyFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 12,
          weight: 500,
        },
        padding: 16,
        boxShadow:
          "0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05)",
        callbacks: {
          label: function (context) {
            var value = context.dataset.data[context.dataIndex];
            var result = Number(value).toFixed(2);
            return "Current Value: ₹" + result + "L";
          },
        },
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: false,
      },
    },
  };

  // const numBars = investors_and_investment_data.labels.length;
  // const height = numBars * 40; // adjust this value as needed

  //________________________________________________________________________________________________________________

  // const bgColors = ["#3281B7", "#2E927C", "#EF9921", "#7EA8C2", "#73A59C", "#F7CC8B", "#3281B7", "#2E927C", "#EF9921", "#7EA8C2", "#73A59C", "#F7CC8B"];
  // const dataaa = {
  //   labels: data.map((startup) => startup.Startup_Name),
  //   datasets: [
  //     {
  //       data: data.map((startup) => startup.t_amt_inv),
  //       //backgroundColor: ["#3281B7","#2E927C","#EF9921","#7EA8C2","#73A59C","#F7CC8B","#3281B7","#2E927C","#EF9921","#7EA8C2","#73A59C","#F7CC8B"]
  //       //backgroundColor:  bgColors.map((color) => color.at),
  //       backgroundColor: ["#3281B7"],
  //       //(ctx)=> this.getColor(ctx)
  //     },
  //   ],
  // };

  //console.log(typeof v1m1);
  //  console.log(JSON.stringify(tmdataaa1, null, 2));
  //console.log(JSON.stringify(data2, null, 2));

  // const chartContainerRef = useRef(null);
  // useEffect(() => {
  //   const numBars = investors_and_investment_data.labels.length;
  //   const defaultHeight = 250;
  //   const dynamicHeight = Math.max(numBars * 40, defaultHeight);
  //   setChartHeight(dynamicHeight);

  //   const handleResize = () => {
  //     if (chartContainerRef.current) {
  //       const newHeight = chartContainerRef.current.offsetHeight;
  //       setChartHeight(newHeight);
  //     }
  //   };

  //   window.addEventListener('resize', handleResize);
  //   handleResize(); // Set initial height

  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  // // re-render for pie
  // const [chartData2, setChartData2] = useState(domain_composition_data);
  // const hbchartRef = useRef(null);

  // useEffect(() => {
  //   const resizeHandler = () => {
  //     const chartInstance = hbchartRef.current.chartInstance;
  //     if (chartInstance) {
  //       // Update the chart data as needed
  //       const newChartData = { ...domain_composition_data };
  //       setChartData2(newChartData);
  //       chartInstance.update();
  //     }
  //   };

  //   window.addEventListener("resize", resizeHandler);

  //   // Clean up the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("resize", resizeHandler);
  //   };
  // }, [domain_composition_data, v1inv]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: "#2196f3",
            marginBottom: 2,
          }}
        />
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: "#333",
            textAlign: "center",
          }}
        >
          Loading...
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            marginTop: 1,
            textAlign: "center",
          }}
        >
          Please wait while we fetch your data
        </Typography>
      </Box>
    );
  }

  if (error)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h5">Error: {error.message}</Typography>
      </Box>
    );

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>Finvolve - Wealth Manager Dashboard</title>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>

      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #E2E8F0",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
          position: "sticky",
          top: 0,
          zIndex: 100,
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 2, sm: 3, lg: 4 },
            py: { xs: 0.75, sm: 1 },
            flexWrap: { xs: "wrap", sm: "nowrap" },
            gap: { xs: 1, sm: 2 },
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <Box
            component="img"
            src={iconforfvlogo}
            alt="Finvolve Logo"
            sx={{
              width: { xs: "90px", sm: "110px", lg: "130px" },
              height: { xs: "32px", sm: "40px", lg: "48px" },
              objectFit: "contain",
              filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))",
              flexShrink: 0,
            }}
          />

          <Box
            sx={{
              display: "flex",
              gap: { xs: 1, sm: 2 },
              alignItems: "center",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              flexShrink: 1,
              minWidth: 0,
            }}
          >
            <Button
              variant="outlined"
              href="/wmpassword-reset"
              sx={{
                color: "#3B82F6",
                borderColor: "#E2E8F0",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: 12, sm: 13 },
                padding: { xs: "6px 12px", sm: "8px 16px" },
                borderRadius: "8px",
                minWidth: { xs: "auto", sm: "110px" },
                height: { xs: "32px", sm: "36px" },
                flexShrink: 1,
                "&:hover": {
                  backgroundColor: "#F8FAFC",
                  borderColor: "#3B82F6",
                },
              }}
            >
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                Reset Password
              </Box>
              <Box
                component="span"
                sx={{ display: { xs: "inline", sm: "none" } }}
              >
                Reset
              </Box>
            </Button>
            <Button
              variant="contained"
              href="/wealth-manager-login"
              onClick={handleLinkClickfvwm}
              sx={{
                backgroundColor: "#EF4444",
                color: "white",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: 12, sm: 13 },
                padding: { xs: "6px 12px", sm: "8px 16px" },
                borderRadius: "8px",
                minWidth: { xs: "auto", sm: "90px" },
                height: { xs: "32px", sm: "36px" },
                flexShrink: 1,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#DC2626",
                  boxShadow: "0 2px 4px rgba(239, 68, 68, 0.2)",
                },
              }}
            >
              Sign Out
            </Button>
            <Button
              onClick={() => window.print()}
              variant="contained"
              sx={{
                backgroundColor: "#6B7280",
                color: "white",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: 12, sm: 13 },
                padding: { xs: "6px 12px", sm: "8px 16px" },
                borderRadius: "8px",
                minWidth: { xs: "auto", sm: "90px" },
                height: { xs: "32px", sm: "36px" },
                flexShrink: 1,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#4B5563",
                  boxShadow: "0 2px 4px rgba(107, 114, 128, 0.2)",
                },
              }}
            >
              <PrintIcon
                sx={{ mr: { xs: 0.5, sm: 1 }, fontSize: { xs: 14, sm: 16 } }}
              />
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                Print Out
              </Box>
              <Box
                component="span"
                sx={{ display: { xs: "inline", sm: "none" } }}
              >
                Print
              </Box>
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Main Content Area */}
      <Box sx={{ flex: 1, p: { xs: 2, lg: 4 } }}>
        {/* Welcome Message and Filter Button Row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: { xs: 2, sm: 3 },
            flexWrap: { xs: "wrap", sm: "nowrap" },
            gap: { xs: 1, sm: 0 },
          }}
        >
          <Typography
            fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
            variant="h4"
            fontWeight={500}
            color="#000000"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", lg: "2.125rem" },
              lineHeight: { xs: 1.2, sm: 1.3 },
              wordBreak: "break-word",
            }}
          >
            Welcome back, {wealth_manager}
          </Typography>
          <Button
            onClick={handleClickOpen}
            sx={{
              backgroundColor: "#3B82F6",
              color: "white",
              borderRadius: "50%",
              minWidth: { xs: "40px", sm: "48px" },
              width: { xs: "40px", sm: "48px" },
              height: { xs: "40px", sm: "48px" },
              padding: 0,
              flexShrink: 0,
              "&:hover": {
                backgroundColor: "#2563EB",
                transform: "scale(1.05)",
                transition: "all 0.2s ease-in-out",
              },
            }}
          >
            <FilterListIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
          </Button>
        </Box>

        {/* Overview */}
        <Grid
          container
          spacing={2.5}
          sx={{ backgroundColor: "transparent", mb: 2 }}
        >
          {[
            {
              icon: CategoryIcon,
              iconColor: "#06B6D4",
              label: "Domains Covered",
              value: domains_covered,
            },
            {
              icon: BusinessIcon,
              iconColor: "#F59E0B",
              label: "Startups Covered",
              value: startups_covered,
            },
            {
              icon: PeopleIcon,
              iconColor: "#8B5CF6",
              label: "Investors",
              value: investors_covered,
            },
            {
              icon: AttachMoneyIcon,
              iconColor: "#3B82F6",
              label: "Total Investments",
              value: formatter.format(total_inv) + "L",
            },
            {
              icon: AccountBalanceWalletIcon,
              iconColor: "#10B981",
              label: "Current AUM",
              value: formatter.format(current_value) + "L",
            },
            {
              icon: TrendingUpIcon,
              iconColor: pnl >= 0 ? "#10B981" : "#EF4444",
              label: "Unrealized P&L",
              value: formatter.format(pnl) + "L",
              color: "#111827",
            },
            {
              icon: AttachMoneyIcon,
              iconColor: "#3B82F6",
              label: "Commitment Amount",
              value: 0 + "L",
            },
            {
              icon: TrendingUpIcon,
              iconColor: "#10B981",
              label: "Fundwise Commitment Amount",
              value: 0 + "L",
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  background:
                    "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                  borderRadius: "16px",
                  padding: "20px",
                  border: "1px solid #E2E8F0",
                  boxShadow:
                    "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 3,
                  width: "100%",
                  minHeight: "90px",
                  height: "90px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: item.iconColor,
                    borderRadius: 2,
                    padding: 1.5,
                    width: { xs: 32, sm: 40 },
                    height: { xs: 32, sm: 40 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <item.icon
                    sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    minWidth: 0,
                    flex: 1,
                  }}
                >
                  <Typography
                    fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                    fontSize={{ xs: 12, sm: 14 }}
                    color="#4B5563"
                    fontWeight={600}
                    title={item.label}
                    sx={{
                      mb: 0.5,
                      letterSpacing: "0.025em",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                    fontSize={{ xs: 16, sm: 18, lg: 20 }}
                    fontWeight={500}
                    color={item.color || "#1F2937"}
                    sx={{
                      letterSpacing: "0.025em",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Bank Account Details - Hidden for now */}
      {/* <Box
        sx={{ margin: 2, mb: 2, pl: { xs: 2, lg: 4 }, pr: { xs: 2, lg: 4 } }}
      >
        <Card
          elevation={0}
          sx={{
            p: "20px",
            borderRadius: 3,
            background: "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
            boxShadow:
              "0 10px 35px rgba(0, 0, 0, 0.08), 0 2px 12px rgba(0, 0, 0, 0.04)",
            border: "1px solid #E2E8F0",
          }}
        >
          <Typography
            variant="h5"
            component="div"
            fontWeight="bold"
            sx={{ mb: 3, color: "#1E293B" }}
          >
            Bank Account Details
          </Typography>
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            {[
              { label: "Account Holder:" },
              { label: "Account Number:" },
              { label: "Bank Name:" },
              { label: "IFSC Code:" },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    py: 2,
                    px: 1,
                  }}
                >
                  <Typography
                    variant="body1"
                    component="div"
                    fontWeight="600"
                    sx={{
                      color: "#111827",
                      fontSize: "16px",
                      letterSpacing: "0.025em",
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Box> */}

      <Grid
        container
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="start"
        mt={2}
        mb={2}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "350px", sm: "400px", lg: "450px" },
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Current value of Investments - Investor Wise
            </Typography>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {chartData && (
                <Bar
                  data={chartData}
                  options={investors_and_investment_options}
                  plugins={[ChartDataLabels]}
                />
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Startups Composition - Full Width */}
      <Grid
        container
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="start"
        mt={2}
        mb={2}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "300px", sm: "350px", lg: "380px" },
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Startups Composition
            </Typography>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Line
                data={composition_of_startups_data}
                plugins={[ChartDataLabels]}
                options={composition_of_startups_options}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* <Grid container
        sx={{ backgroundColor: '#F7F7F7' }}
        display={'flex'}
        justifyContent='space-evenly'
        pt={2}
        //sx={{ border: "solid" }}
      >
        <Grid item p={1} m={1} lg={12}>
          <Paper elevation={3} sx={{ paddingLeft:'10px', paddingRight:'10px', borderRadius: '10px', border: 'none', height: '120px'}} >
          <TreemapChart data={dataaa} />
          </Paper></Grid>
      </Grid> */}

      <Grid
        container
        spacing={2}
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="start"
        mt={2}
        mb={2}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        <Grid className="half" item xs={12} lg={6}>
          <Paper
            elevation={0}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "300px", sm: "350px", lg: "400px" },
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "100%",
                justifyContent: "flex-start",
              }}
            >
              <FundTypeComposition data={v1inv} />
            </Box>
          </Paper>
        </Grid>

        <Grid className="half" item xs={12} lg={6}>
          <Paper
            elevation={0}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "300px", sm: "350px", lg: "400px" },
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Domain Composition
            </Typography>
            <Doughnut
              data={domain_composition_data}
              plugins={[ChartPieChartOutlabels]}
              //  plugins={[ChartDataLabels]}
              options={domain_composition_options}
            />
          </Paper>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="start"
        mt={1}
        mb={0}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
        //sx={{ border: "solid" }}
      >
        <Grid className="full" item p={{ xs: 2, lg: 1 }} xs={12} lg={12}>
          <Paper
            sx={{
              padding: "20px",
              maxWidth: "100%",
              minHeight: "360px",
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
            elevation={0}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Investor Summary
            </Typography>
            <TableContainer
              m={0}
              p={0}
              sx={{
                minHeight: "500px",
                maxHeight: "500px",
                width: "100%",
                overflowX: "auto",
                overflowY: "auto",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
            >
              <Table
                aria-label="simple table"
                size="small"
                stickyHeader
                sx={{
                  tableLayout: "fixed",
                  width: "100%",
                  minWidth: "1200px",
                }}
              >
                <TableHead
                  sx={{
                    "& .MuiTableCell-root": {
                      backgroundColor: "#F8FAFC",
                      fontWeight: 600,
                      borderBottom: "1px solid #E5E7EB",
                      padding: "16px 12px",
                      fontSize: "14px",
                      color: "#111827",
                      whiteSpace: "nowrap",
                      minWidth: "120px",
                    },
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "180px",
                      }}
                      align="left"
                    >
                      Investor
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "black",
                      }}
                      align="center">
                      Funds Invested
                    </TableCell> */}
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "150px",
                      }}
                      align="center"
                    >
                      Startups Covered
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "150px",
                      }}
                      align="center"
                    >
                      Amount Invested
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "140px",
                      }}
                      align="center"
                    >
                      Current Value
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "120px",
                      }}
                      align="center"
                    >
                      P&L
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "100px",
                      }}
                      align="center"
                    >
                      P&L%
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tdata2.map((tdata2, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: "#FFFFFF",
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "#F8FAFC",
                          cursor: "pointer",
                          "& td": {
                            backgroundColor: "transparent",
                          },
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px 8px",
                          wordBreak: "break-word",
                          lineHeight: 1.4,
                        }}
                        align="left"
                      >
                        {tdata2.investor}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "18",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {tdata2.fundcount}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        {tdata2.startupcount}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{parseFloat(tdata2.invested_value).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{parseFloat(tdata2.currentvalue_value).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{parseFloat(tdata2.pnlvalue).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        {parseFloat(tdata2.pnlpercent).toFixed(2)}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        {/* <Grid item p={{ xs: 3, lg: 0 }} pt={{ xs: 0, lg: 1 }} pl={{ xs: 3, lg: 0 }} pr={{ xs: 3, lg: 2 }} xs={12} lg={3}>
          <Paper
            elevation={2}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "250px", sm: "280px", lg: "320px" },
              borderRadius: "16px",
              background: "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
              border: "1px solid #E2E8F0",
              boxShadow: "0 8px 25px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04)"
            }}>
            <Typography fontFamily={"Arial"} fontSize={18} fontWeight={500} color={"Black"} height={"6%"}>
              AUM Breakdown
            </Typography>
            <Bar data={aum_breakdown_data} plugins={[ChartDataLabels]} options={aum_breakdown_options} />
          </Paper>
        </Grid> */}
      </Grid>

      <Grid
        className="full"
        container
        spacing={3}
        display={"flex"}
        wrap="nowrap"
        mt={1}
        mb={0}
        justifyContent="space-evenly"
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        {/* <Grid item p={2} m={0} xs={12} lg={12}> */}
        <Grid
          item
          p={{ xs: 2, lg: 1 }}
          pl={{ xs: 2, lg: 2 }}
          ml={{ xs: 0, lg: 0 }}
          xs={12}
          lg={12}
        >
          <Paper
            sx={{
              padding: "20px",
              maxWidth: "100%",
              minHeight: "360px",
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
            elevation={0}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Transaction Summary
            </Typography>
            <TableContainer
              m={0}
              p={0}
              sx={{
                minHeight: "500px",
                maxHeight: "500px",
                width: "100%",
                overflowX: "auto",
                overflowY: "auto",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
            >
              <Table
                aria-label="simple table"
                size="small"
                stickyHeader
                sx={{
                  tableLayout: "fixed",
                  width: "100%",
                  minWidth: "1400px",
                }}
              >
                <TableHead
                  sx={{
                    "& .MuiTableCell-root": {
                      backgroundColor: "#F8FAFC",
                      fontWeight: 600,
                      borderBottom: "1px solid #E5E7EB",
                      padding: "16px 12px",
                      fontSize: "14px",
                      color: "#111827",
                      whiteSpace: "nowrap",
                      minWidth: "120px",
                    },
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "120px",
                      }}
                      align="left"
                    >
                      Issue Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "160px",
                      }}
                      align="left"
                    >
                      Investor
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "black",
                      }}
                      align="center">
                      Fund
                    </TableCell> */}
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "160px",
                      }}
                      align="center"
                    >
                      Invested Startup
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "100px",
                      }}
                      align="center"
                    >
                      Round
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "140px",
                      }}
                      align="center"
                    >
                      Investment Route
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "100px",
                      }}
                      align="center"
                    >
                      Units
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "120px",
                      }}
                      align="center"
                    >
                      Avg. NAV
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "130px",
                      }}
                      align="center"
                    >
                      Current NAV
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "140px",
                      }}
                      align="center"
                    >
                      Amount Invested
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "130px",
                      }}
                      align="center"
                    >
                      Current Value
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "100px",
                      }}
                      align="center"
                    >
                      P&L
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily:
                          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                        fontSize: "14",
                        color: "#111827",
                        fontWeight: 600,
                        textTransform: "none",
                        letterSpacing: "0",
                        whiteSpace: "nowrap",
                        width: "100px",
                      }}
                      align="center"
                    >
                      P&L%
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tdata.map((tdata, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: "#FFFFFF",
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "#F8FAFC",
                          cursor: "pointer",
                          "& td": {
                            backgroundColor: "transparent",
                          },
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        component="th"
                        scope="row"
                      >
                        {tdata.issuedate2}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px 8px",
                          wordBreak: "break-word",
                          lineHeight: 1.4,
                        }}
                        align="left"
                      >
                        {tdata.investor}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "18",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {tdata.fundname}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px 8px",
                          wordBreak: "break-word",
                          lineHeight: 1.4,
                        }}
                        align="center"
                      >
                        {tdata.startupname}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        {tdata.round}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px 8px",
                          wordBreak: "break-word",
                          lineHeight: 1.4,
                        }}
                        align="center"
                      >
                        {tdata.fundType}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        {tdata.units}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{tdata.unitprice}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{tdata.Cunitprice}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{parseFloat(tdata.ival_l).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{parseFloat(tdata.Cval_l).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        ₹{parseFloat(tdata.pnl).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily:
                            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                          fontSize: "14",
                          fontWeight: 400,
                          color: "#111827",
                          padding: "12px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center"
                      >
                        {parseFloat(tdata.pnlp).toFixed(2)}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>

      {/* Investment Value by Month - Full Width */}
      <Grid
        container
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="start"
        mt={2}
        mb={2}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "300px", sm: "350px", lg: "380px" },
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Investment Value by Month
            </Typography>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Bar
                data={investment_value_by_month_data}
                plugins={[ChartDataLabels]}
                options={investment_value_by_month_options}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Investors Engaged - Full Width */}
      <Grid
        container
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="start"
        mt={2}
        mb={2}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              padding: "20px",
              maxWidth: "100%",
              height: { xs: "300px", sm: "350px", lg: "380px" },
              borderRadius: "20px",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={
                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              }
              fontSize={22}
              fontWeight={500}
              color={"#0F172A"}
              mb={2}
              sx={{
                letterSpacing: "-0.025em",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Investors Engaged
            </Typography>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Bar
                data={investors_engaged_data}
                plugins={[ChartDataLabels]}
                options={investors_engaged_options}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Filter Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottom: "1px solid #E2E8F0",
            fontWeight: 600,
            fontSize: "18px",
            color: "#1E293B",
            padding: "20px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Filters
          <Button
            onClick={handleClose}
            sx={{
              minWidth: "auto",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#F1F5F9",
              color: "#64748B",
              "&:hover": {
                backgroundColor: "#E2E8F0",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </Button>
        </DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: "#FFFFFF",
            padding: "32px 24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <Box sx={{ maxWidth: "350px", width: "100%" }}>
            <FormControl
              fullWidth
              size="small"
              sx={{ mb: 2, textAlign: "center" }}
            >
              <InputLabel id="funds-label">Funds</InputLabel>
              <Select
                labelId="funds-label"
                id="funds-select"
                multiple
                value={cfundsName}
                onChange={handleChangecfunds}
                input={<OutlinedInput label="Funds" />}
                renderValue={(selected) => selected.join(", ")}
                sx={{
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#3B82F6",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3B82F6",
                    },
                  },
                }}
              >
                {checks_funds.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={cfundsName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              sx={{ mb: 2, textAlign: "center" }}
            >
              <InputLabel id="startups-label">Startups</InputLabel>
              <Select
                labelId="startups-label"
                id="startups-select"
                multiple
                value={cstartupName}
                onChange={handleChangecstartup}
                input={<OutlinedInput label="Startups" />}
                renderValue={(selected) => selected.join(", ")}
                sx={{
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#3B82F6",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3B82F6",
                    },
                  },
                }}
              >
                {checks_startup.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={cstartupName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth size="small" sx={{ textAlign: "center" }}>
              <InputLabel id="domains-label">Domains</InputLabel>
              <Select
                labelId="domains-label"
                id="domains-select"
                multiple
                value={cdomainName}
                onChange={handleChangecdomain}
                input={<OutlinedInput label="Domains" />}
                renderValue={(selected) => selected.join(", ")}
                sx={{
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#3B82F6",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3B82F6",
                    },
                  },
                }}
              >
                {checks_domain.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={cdomainName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "#FFFFFF",
            borderTop: "1px solid #E2E8F0",
            padding: "16px 24px",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button
            onClick={handleClearFilters}
            variant="outlined"
            sx={{
              color: "#6B7280",
              borderColor: "#D1D5DB",
              textTransform: "none",
              fontWeight: 500,
              padding: "8px 20px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "#F9FAFB",
                borderColor: "#9CA3AF",
              },
            }}
          >
            Clear Filters
          </Button>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: "#3B82F6",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              padding: "8px 24px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "#2563EB",
              },
            }}
          >
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Footer Section with Data as of now */}
      <Grid
        container
        sx={{ backgroundColor: "transparent" }}
        display={"flex"}
        justifyContent="flex-start"
        pt={0}
        mt={2}
        mb={2}
        pl={{ xs: 2, lg: 4 }}
        pr={{ xs: 2, lg: 4 }}
      >
        <Grid item lg={6}>
          <Grid
            container
            display={"flex"}
            justifyContent="flex-start"
            pt={0}
            mt={0}
          ></Grid>
        </Grid>
        <Grid item lg={6}>
          <Grid
            container
            display={"flex"}
            direction={"row-reverse"}
            justifyContent="flex-start"
            pr={1}
            mt={0}
          >
            <Grid
              item
              pl={{ xs: 3, lg: 1 }}
              pt={{ xs: 0, lg: 5 }}
              pr={{ lg: 2 }}
            >
              <Typography
                fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                fontSize={14}
                color="#64748B"
                fontWeight={500}
              >
                {`Data as of now: 15-Feb-2026`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default Dashhwm;
